module.exports = __webpack_public_path__ + "img/xy.3e489bc2.svg";